import { DrawerReturnTypeWithPayload } from '../../../hooks/useDrawer'
import { TChatTypeUnion } from '../../../constants'

export const defaultSideDrawer: DrawerReturnTypeWithPayload<{
  type: TChatTypeUnion
}> = {
  state: {
    visible: false,
    title: '',
    width: 420,
    payload: { type: '' as TChatTypeUnion },
    onClose: () => undefined
  },
  actions: {
    close: () => undefined,
    open: () => undefined,
    setState: () => undefined
  }
}
